module.exports = __webpack_public_path__ + "assets/img/close_small.4245fabb.svg";